import { api } from '@/api';
import { useActionWithConfirmation } from '@/components/confirmationModals/useActionWithConfirmation';

export function useDeleteEnumerationWithConfirmation() {
  return useActionWithConfirmation({
    confirmedAction: async (id: string) =>
      await api.enumerationQuantitiesApi.deleteEnumerationQuantity({
        id: id,
      }),
  });
}
